import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-796bb644"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-indicator-page-top" }
const _hoisted_2 = {
  key: 0,
  class: "extended-loading-panel"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h3 data-v-796bb644>Loading App and Content...</h3><div class=\"loaderBalls-container\" data-v-796bb644><div class=\"loaderBalls\" data-v-796bb644><div class=\"loaderBalls--dot\" data-v-796bb644></div><div class=\"loaderBalls--dot\" data-v-796bb644></div><div class=\"loaderBalls--dot\" data-v-796bb644></div><div class=\"loaderBalls--dot\" data-v-796bb644></div><div class=\"loaderBalls--dot\" data-v-796bb644></div><div class=\"loaderBalls--dot\" data-v-796bb644></div></div></div>", 2)
const _hoisted_5 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        style: _normalizeStyle({ width: _ctx.percentage })
      }, null, 4)
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true)
  ], 64))
}